import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepperData = ["内容入力", "機構へ提出"];

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "延長の対象となる掛金（年度）",
    keyword: "premiumsForExtensio",
    type: "text",
    helpicon: true,
    helpText: "納付期限の延長申請の対象となる掛金は当年度分のみとなります。",
  },
  {
    title: "延長の対象となる掛金（金額）",
    keyword: "premiumsForExtensioAmount",
    type: "text",
    helpicon: true,
    helpText:
      "納付期限の延長申請の対象となる掛金を表示しています。既契約掛金については、掛金納付対象職員届で届出られた職員数で算定した金額です。",
  },
  {
    title: "希望する延長期限日付",
    keyword: "applyDate",
    type: "date",
    maxDate: new Date(new Date().getFullYear(), 0, 31),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
    helpicon: true,
    helpText: "希望する延長期限日付です。最長は翌１月３１日です。",
  },
  {
    title: "延長前の納付期限",
    keyword: "deadlineBeforeExtension",
    type: "text",
    helpicon: true,
    helpText: "本来の納付期限を表示しています。",
  },
  {
    title: `延長申請理由※具体的に記入`,
    keyword: "extensionApplyReason",
    type: "textarea",
    requiredIcon: true,
    helpicon: true,
    helpText: "掛金の延長を申請する理由を具体的に記入してください。",
  },
  {
    title: "延長申請の理由証明書",
    keyword: "fileUpload",
    type: "fileUpload",
    helpicon: true,
    helpText:
      "理由証明書（（例）風水害等（市町村長）、火災・地震等（消防署長又は市町村長）、感染症（保健所長））を添付してください。",
  },
  {
    title: "備考",
    keyword: "remark",
    type: "textarea",
  },
];
const schema = {
  applyDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  extensionApplyReason: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
  remark: {
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

export { schema, stepperData, fakeTableList };
